import VueRouter from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('./components/HelloWorld.vue'),
  },
  {
    path: '/polizas',
    component: () => import('./components/pages/PolizasPage.vue'),
  },
  {
    path: '/contable',
    component: () => import('./components/pages/ContablePage.vue'),
  },
  {
    path: '/gestion',
    component: () => import('./components/pages/GestionPage.vue'),
  },
  {
    path: '/presentacion',
    name: 'PresentacionComercial',
    component: () => import('./components/pages/PresentacionComercial.vue'),
    meta: { fullscreen: true, title: 'RECC — Presentación Comercial' }
  },
  {
    path: '/institucional',
    name: 'PresentacionInstitucional',
    component: () => import('./components/pages/PresentacionInstitucional.vue'),
    meta: { fullscreen: true, title: 'RECC — Presentación Institucional' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
});

export default router;
